<template xmlns="http://www.w3.org/1999/html">

  <div id="background"
    style="width: 100vw;
    position:fixed;
    background: url(/static/images/quax/bg3.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;align-items: center;">

    <img src="/static/images/quax/logo.png" alt=""
      style="z-index: 1;width: 35vw;height: auto;position: absolute;top:3vh" />
    <img src="/static/images/quax/girl.png" alt="" style="width: 100vw;height: auto;position: absolute;" />
    <img src="/static/images/quax/xuanchuan.png" alt="" style="width: 35vw;;position: absolute;bottom:4vh" />

    <div class="card">
      <div style="display: flex;justify-items: center;align-items:center;width: 100%;">
        <div style="width: 63%;text-align: right;z-index:1;margin-top: 3vh;">
          <img src="/static/images/quax/antiinfo.png" alt=""
            style="z-index: 1;width: 20vw;height: auto;margin-top: 0.5vh;" />
        </div>
        <div style="width: 37%;text-align: right;z-index:1;margin-top: 3vh;">
          <span v-if="showScore" style="font-size: 13px;z-index: 1;text-decoration: underline;margin-right: 20px;"
            @click="openPopup">活动规则</span>
        </div>
      </div>

      <div style="z-index:1;width: 90%;height: 10vh;
      background-color: white;border: 0px;margin-top: 3vh;
      border-radius: 30px;font-size: 12px;
      display: flex;align-items: center;justify-content: center;text-align: center;">
        您查询的防伪码为：{{ antiCodeResult }}<br />产品内校验码为：{{ checkCode }}
      </div>

      <div v-if="antiTrue" style="z-index:1;width: 90%;font-size: 12px;text-align: center;margin-top: 3vh;"
        v-html="antiresult">
      </div>
      <div v-if="antiTrue" style="z-index:1;width: 90%;font-size: 13px;font-weight: bold;text-align: center;margin-top: 1vh;">
        {{productName}}
      </div>

      <div v-if="!antiTrue" style="z-index:1;width: 90%;font-size: 12px;text-align: center;margin-top: 3vh;">
        您查询的数码不存在。<br />谨防假冒,请核对后重新查询。
      </div>

      <div v-if="showScore && getGift == 1" style="z-index:1;width: 90%;height: 16vh;
      background-color: white;border: 0px;margin-top: 3vh;
      border-radius: 30px;font-size: 12px;
      display: flex;flex-direction: column;align-items: center;justify-content: center;text-align: center;">
        <span style="font-size: 13px;color: rgb(106, 106, 106);">恭喜您获取{{ jfValue }}积分</span>
        <span style="font-size: 13px;font-weight: bold;margin-top: 1vh;"><span style="font-size: 17px;color: red;">{{
          jfValue }}</span>积分</span>
        <wx-open-launch-weapp id="launch-btn" style="z-index: 999;position: relative;" :appid="miniAppId"
          :username="miniAppOriginalId" :path="miniAppPage">
          <script type="text/wxtag-template">
            <input type="button" value="积分兑换" style="border: none;
                                                            z-index: 999;
                                                            color: white;
                                                            margin-top:5px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            background: linear-gradient(to bottom,rgb(111,88,173), rgb(108,114,211));
                                                            width: 220px;height: 35px;" />
                                    </script>
        </wx-open-launch-weapp>
      </div>

      <div v-if="showScore && getGift == 2" style="z-index:1;width: 90%;height: 16vh;
      background-color: white;border: 0px;margin-top: 3vh;
      border-radius: 30px;font-size: 12px;
      display: flex;flex-direction: column;align-items: center;justify-content: center;text-align: center;">
        <span style="font-size: 13px;color: rgb(106, 106, 106);">抱歉</span>
        <span style="font-size: 16px;font-weight: bold;margin-top: 1vh;">积分已被领完</span>

        <wx-open-launch-weapp id="launch-btn" style="z-index: 999;position: relative;" :appid="miniAppId"
          :username="miniAppOriginalId" :path="miniAppPage">
          <script type="text/wxtag-template">
            <input type="button" value="积分兑换" style="border: none;
                                                            z-index: 999;
                                                            color: white;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            margin-top:5px;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            background: linear-gradient(to bottom,rgb(111,88,173), rgb(108,114,211));
                                                            width: 220px;height: 35px;" />
                                    </script>
        </wx-open-launch-weapp>
      </div>
      <div v-if="antiTrue"
        style="text-align: center;width: 100%;z-index: 1;display: flex;flex-direction: column;margin-top: 3vh;">
        <span style="font-size: 13px;">查看质检报告</span>
        <span style="font-size: 13px;text-decoration: underline;margin-top: 1vh;font-weight: bold;"
          @click="openPDF">下载PDF质检报告</span>
      </div>
    </div>



    <!--活动规则开始-->
    <div v-if="showRule" style="z-index: 1;">
      <div id="activityRule" class="modal" @click="closePopup()"></div>
      <div class="modal-content">
        <div
          style="width: 85%;position: absolute;position: absolute;top: 9%;text-align: center;display: flex;flex-direction: column;align-items: center;">
          <span>规则说明</span>
          <div style="width: 100%;text-align: left;font-size: 12px;line-height: 2.5;margin-top: 30px;text-indent: -10;">
            <div style="display: flex;text-align: left;">
              <span style="margin-right: 3px;">1.</span>正品QUAX产品有防伪数码，用户购买后扫码查询，并输入6位正确校验码后查询真伪;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">2.</span>首次查询后点击参与活动可领取积分;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">3.</span>活动积分只第一次有效，重复扫码无积分;
            </div>
            <div style="display: flex;">
              <span style="margin-right: 3px;">4.</span>最终活动解释权归上海跨时护理有限公司所有。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--活动规则结束-->

    <!--预览pdf开始-->
    <div v-if="showpdf" style="z-index: 1;">
      <div id="pdf" class="modal" @click="closePDF()"></div>
      <div class="modal-pdf">
        <img src="/static/images/quax/pdf.png" style="width: 100%;overflow-y: scroll;" />
      </div>
    </div>
    <!--预览pdf结束-->
  </div>
</template>

<style scoped>
.modal {
  position: fixed;
  /* 固定位置 */
  z-index: 1;
  /* 位于顶层 */
  left: 0;
  top: 0;
  width: 100%;
  /* 宽度全屏 */
  height: 100%;
  /* 高度全屏 */
  overflow: auto;
  background-color: rgba(116, 116, 116, 0.5);
  /* 超出内容可滚动 */
}

/* 模态内容 */
.modal-content {
  overflow: auto;
  background-color: white;
  margin: 70% auto;
  /* 上下自动，左右15% */
  padding: 25px;
  border: 0px;
  width: 80vw;
  height: 300px;
  text-align: center;
  z-index: 2;
  border-radius: 20px;
  position: relative;
}

.modal-pdf {
  overflow: auto;
  background-color: white;
  margin: 30% auto;
  /* 上下自动，左右15% */
  padding: 25px;
  border: 0px;
  width: 90vw;
  height: 70vh;
  text-align: center;
  z-index: 2;
  border-radius: 0px;
  border-radius: 20px;
  position: relative;
}


.card {
  position: absolute;
  height: 62vh;
  width: 80vw;
  bottom: 10vh;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgb(240, 217, 231), rgb(191, 224, 242));
  box-shadow: 0px 0px 15px 0px rgb(232, 208, 238);
  border-radius: 35px;
}

.card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgb(240, 217, 231), rgb(191, 224, 242));
  filter: blur(60px);
  border-radius: 35px;
  box-shadow: 0px 0px 15px 0px rgb(232, 208, 238);
}
</style>


<script>
import { queryAntiCheck, getJSSDK, joinCheckActivity, getTemplate, getScoreConfig, registerByOpenId,getInfoByCode } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      showCheckCode: false,
      checkCode: "",
      antiCodeResult: "",
      antiresult: "",
      antiTrue: false,
      eno: "",
      authCode: "",
      deptId: 0,
      activityId: 0,
      shopUrl: "",
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
      showScore: false,
      showRule: false,
      userToken: "",
      getGift: 0,
      jfValue: 0,
      showpdf: false,
      productName:""
    }
  },
  methods: {
    async getCodeInfo() {
      const res=await getInfoByCode(this.antiCode)
        this.productName = res.data.data.productName
    },
    openPDF() {
      this.showpdf = true
    },
    closePDF() {
      this.showpdf = false
    },
    openPopup() {
      this.showRule = true
    },
    closePopup() {
      this.showRule = false
    },
    async getResult() {
      console.log(this.authCode, this.antiCode, this.checkCode, this.eno)
      const result = await queryAntiCheck(this.antiCode, this.checkCode, this.eno, this.authCode);
      const data = result.data;
      if (data == null || data.code == "500") {
        alert("防伪查询失败,请联系管理员");
      } else {
        this.antiCodeResult = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ')
        if (data.code == "300101" || data.code == "300102") {
          this.antiTrue = true
          this.antiresult = data.data.replyData
          this.deptId = data.data.deptId
          this.getCodeInfo()
        } else {
          this.antiTrue = false
          this.showScore = false
        }
      }

    },
    async getScoreConfig() {
      const res = await getScoreConfig(this.deptId)
      if (res.data.data == null) {
        this.showScore = false
      } else {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }
    },
    async getTemplate() {
      const res = await getTemplate(this.deptId)
      if (res.data.data == null) {
        this.showScore = false
      } else {
        this.activityId = res.data.data.activityId;
        this.activityRule = res.data.data.activityRule;
        this.showScore = true
      }
    },
    async joinActivity() {
      const registerResult = await registerByOpenId(this.eno, this.authCode)
      if (registerResult.data.code == "500") {
        alert("用户登录异常，请联系管理员")
        return
      } else {
        this.userToken = registerResult.data.data.token
      }


      const data = {
        code: this.antiCode,
        activityId: this.activityId,
        authCode: this.authCode,
        userToken: this.userToken,
        checkCode: this.checkCode
      }

      const result = await joinCheckActivity(data)
      if (result.data.code == "200") {
        this.getGift = 1;
        this.jfValue = result.data.data.giftValue
      } else if (result.data.code == "500001") {
        this.getGift = 2;
      } else {
        this.getGift = 3;
        //alert("领取积分异常，原因：" + result.data.message);
      }
      sessionStorage.removeItem("wechatAuth");
      sessionStorage.removeItem("queryCode");
    }
    ,
    async getConfig() {
      await this.getResult()
      await this.getScoreConfig()
      await this.getTemplate()
      await this.joinActivity()
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx48bec35c126c6e01").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        console.log("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    const params = this.$route.query;
    const eno = params.eno
    const authCode = params.authCode
    const antiCode = params.q
    const checkCode = params.c

    if (eno == null || eno == ""
      || authCode == null || authCode == ""
      || antiCode == null || antiCode == ""
      || checkCode == null || checkCode == "") {
      alert("参数错误，请重新扫码进行查询");
      sessionStorage.removeItem("wechatAuth")
      sessionStorage.removeItem("queryCode")
      return;
    }
    this.eno = eno
    this.antiCode = antiCode
    this.checkCode = checkCode
    this.authCode = authCode
    this.getConfig()
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Quax/Activity.vue